const serviceContent = {
  'general-medicine': {
    name: "General Medicine",
    heading: "Comprehensive Primary Healthcare",
    text: "At Avenra Health Center, our General Medicine department provides preventive care, diagnosis, and treatment of adult illnesses. Whether it's the flu, a chronic disease, or lifestyle management, our experienced doctors are here to help.",
    serviceHeading: "Our Services Include:",
    Services: [
      { title: "Routine health evaluations" },
      { title: "Management of diabetes, hypertension, etc." },
      { title: "Flu, fever, and infection treatments" },
      { title: "Lifestyle counseling and nutrition" },
    ],
    chooseUs: "",
    reasonChoose: [
      { title: "Personalized treatment" },
      { title: "Experienced general physicians" },
      { title: "Full diagnostic support" }
    ],
    faq: [
      {
        question: "How often should I visit a general physician?",
        answer: "Annually, or more often if you have ongoing health concerns or symptoms."
      },
      {
        question: "What health issues are treated under general medicine?",
        answer: "We handle flu, fevers, infections, chronic conditions like diabetes and hypertension, and more."
      },
      {
        question: "Are follow-up consultations included?",
        answer: "Yes, follow-ups are available and scheduled based on your health plan."
      },
      {
        question: "Can I consult for mental health concerns?",
        answer: "Yes, our general physicians can assist and refer you to specialists if needed."
      },
      {
        question: "Are general consultations available on weekends?",
        answer: "Yes, we offer weekend appointments for your convenience."
      }
    ]
  },
  'physiotherapy': {
    name: "Physiotherapy",
    heading: "Move Freely, Live Fully",
    text: "Our expert physiotherapists help restore movement, reduce pain, and prevent disability. Whether you’re recovering from surgery or managing a chronic issue, we provide effective, personalized care.",
    serviceHeading: "What We Treat:",
    Services: [
      { title: "Back and joint pain" },
      { title: "Sports injuries" },
      { title: "Stroke or neurological recovery" },
      { title: "Post-surgery rehabilitation" }
    ],
    chooseUs: "",
    reasonChoose: [
      { title: "One-on-one sessions" },
      { title: "Tailored exercise plans" },
      { title: "Licensed professionals" }
    ],
    faq: [
      {
        question: "Do I need a referral to start physiotherapy?",
        answer: "No, you can directly book a physiotherapy session."
      },
      {
        question: "How long is each session?",
        answer: "Each session lasts 30–60 minutes depending on your treatment plan."
      },
      {
        question: "Is physiotherapy painful?",
        answer: "Initial discomfort is normal, but our therapists work within your tolerance levels."
      },
      {
        question: "How soon can I expect results?",
        answer: "Improvements are usually seen within 3–5 sessions, depending on the condition."
      },
      {
        question: "Do you offer at-home physiotherapy?",
        answer: "Yes, home visits can be arranged based on availability."
      },
    ]
  },
  'pediatrics': {
    name: "Pediatrics",
    heading: "Trusted Care for Growing Children",
    text: "Avenra’s pediatric care ensures your child’s healthy development through every stage. Our compassionate team handles routine wellness checks, vaccinations, and illnesses with expert care.",
    serviceHeading: "Services Offered:",
    Services: [
      { title: "Immunizations & vaccination" },
      { title: "Growth & development tracking" },
      { title: "Nutrition counseling" },
      { title: "Illness and infection care" }
    ],
    chooseUs: "",
    reasonChoose: [
      { title: "Child-friendly environment" },
      { title: "Skilled pediatricians" },
      { title: "Holistic care" }
    ],
    faq: [
      {
        question: "What age group do pediatricians treat?",
        answer: "From newborns to adolescents (up to 18 years of age)."
      },
      {
        question: "Do you keep a vaccination record?",
        answer: "Yes, we maintain detailed vaccination charts and reminders."
      },
      {
        question: " What symptoms should prompt a visit?",
        answer: "High fever, rashes, unusual behavior, digestive issues, or breathing problems."
      },
      {
        question: "Can I get same-day appointments for my child?",
        answer: "We offer emergency slots and flexible scheduling."
      },
      {
        question: "Do you offer developmental assessments?",
        answer: "Yes, including speech, motor skills, and cognitive development."
      }
    ]
  },
  'diagnostics-and-lab-tests': {
    name: "Diagnostics & Lab Tests",
    heading: "Fast. Accurate. Reliable.",
    text: "Our diagnostics department uses advanced technology to deliver quick and accurate test results to support your treatment plans. From basic blood tests to complex scans, we cover it all.",
    serviceHeading: "We Provide:",
    Services: [
      { title: "Pathology (blood, urine tests)" },
      { title: "Radiology (X-ray, ultrasound)" },
      { title: "ECG & heart screenings" },
      { title: "Full-body health packages" },
    ],
    chooseUs: "",
    reasonChoose: [
      { title: "NABL-certified lab" },
      { title: "Fast report turnaround" },
      { title: "Trained technicians" }
    ],
    faq: [
      {
        question: "Can I book a lab test online?",
        answer: "Yes, you can schedule tests and even opt for home sample collection."
      },
      {
        question: "What tests need fasting?",
        answer: " Typically, lipid profile and fasting glucose tests require 8–12 hours of fasting."
      },
      {
        question: "How do I receive my test results?",
        answer: "Results are sent via email, available on our portal, or can be collected in person."
      },
      {
        question: "Are your diagnostic services covered by insurance?",
        answer: "Yes, we work with most insurance providers for select tests."
      },
      {
        question: "Can I get an urgent report on the same day?",
        answer: "We offer express delivery for select tests at an additional cost."
      },
    ]
  },
  'preventive-checkups': {
    name: "Preventive Checkups",
    heading: "Early Detection Saves Lives",
    text: "Our preventive health checkups are designed to help you stay one step ahead. These packages cover essential screenings and consultations to ensure all aspects of your health are monitored.",
    serviceHeading: "Packages Include:",
    Services: [
      { title: "Vital signs monitoring" },
      { title: "Blood sugar & cholesterol levels" },
      { title: "ECG & basic imaging" },
      { title: "General physician consultation" }
    ],
    chooseUs: "",
    reasonChoose: [
      { title: "Detects health risks early" },
      { title: "Personalized health reports" },
      { title: "Lifestyle guidance" }
    ],
    faq: [
      {
        question: "What’s the ideal age to start health checkups?",
        answer: "Begin regular checkups by age 30, earlier if there’s a family history of illnesses."
      },
      {
        question: "Are these packages customizable?",
        answer: "Yes, we can adjust packages to suit your medical history or concerns."
      },
      {
        question: "Will I get a diet or fitness plan afterward?",
        answer: "Yes, our doctors provide basic lifestyle recommendations based on your results."
      },
      {
        question: "How often should I repeat checkups?",
        answer: "Annually is ideal, or as advised by your physician."
      },
      {
        question: "Are these checkups covered under health insurance?",
        answer: "Some packages are eligible for reimbursement. Please check with your insurer."
      }
    ]
  },
  'specialized-consultations': {
    name: "Specialized Consultations",
    heading: "Advanced Expertise, Just a Call Away",
    text: "For conditions that require expert attention, our panel of specialists are here to offer personalized care and detailed evaluations across various medical fields.",
    serviceHeading: "Available Specialties:",
    Services: [
      { title: "Cardiology" },
      { title: "Orthopedics" },
      { title: "Neurology" },
      { title: "Endocrinology" },
    ],
    chooseUs: "",
    reasonChoose: [
      { title: "Leading consultants" },
      { title: "Evidence-based diagnosis" },
      { title: "In-depth patient education" }
    ],
    faq: [
      {
        question: "What is the process to meet a specialist?",
        answer: "You can book directly or be referred by our general physician."
      },
      {
        question: "How long does a specialist appointment last?",
        answer: " Typically 30–45 minutes, depending on the complexity of the issue."
      },
      {
        question: "What should I carry with me?",
        answer: "All previous prescriptions, test reports, and list of symptoms."
      },
      {
        question: "Can I get a second opinion?",
        answer: "Yes, many patients seek us out for trusted second opinions."
      },
      {
        question: "Do specialists coordinate with other departments?",
        answer: "Absolutely. Our team works collaboratively to provide holistic care."
      }
    ]
  }
};

export default serviceContent;
